import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    DateField,
    TextInput,
    EditButton,
    CardActions,
    ListButton,
    SimpleShowLayout,
    Show,
    ShowButton
} from 'react-admin';
import { Redirect } from 'react-router-dom';
import LinkToCreate from './LinkToCreate'
import ViewDetails from './ViewDetails'
import moment from 'moment'

var uid = null;

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

export const NameFilter = props => (
    <Filter {...props}>   
        <TextInput source="name" alwaysOn label='Name'/>
    </Filter>
);

const Actions = ({...props}) => (
    <CardActions style={cardActionStyle}>
        <LinkToCreate uid={props.filterValues.uid} />
        <ListButton basePath={'/userslist'} label="User List" />
        
    </CardActions>
);

const Heading=({data})=>{
    return (<h3>{data}</h3>)
}


const PostShow = props => (
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
    >
        <SimpleShowLayout>
        <table style={{width:"99%", fontSize: "11px"}}>
            <tbody>
            <tr>
                <td colSpan="4">
                    <table  border ="1" cellSpacing="0" style={{width:"100%", textAlign: "center"}}>
                    <tbody>
                    <tr>
                        <td>
                            <table  border ="0" style={{width:"100%", textAlign: "center"}}>
                            <tbody>
                            <tr>
                                <td style={{fontSize: "9px"}}> 
                                    Training and Education Procedures
                                </td>
                            </tr>
                            <tr>
                                <td ><Heading  data={props.record && props.record.name} /></td>
                            </tr>
                           
                            </tbody>
                            </table>
                        </td>                  
                    </tr>
                    </tbody>
                    </table>
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Trainee Name:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainee}</td>
                <td>&nbsp;Center:</td><td style={{width:"35%", border: "1px solid", cellSpacing:"10"}}>{props.record && props.record.location}</td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer1}</td>
                <td>&nbsp;Initial:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer1_init}</td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer2}</td>
                <td>&nbsp;Initial:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer2_init}</td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer3}</td>
                <td>&nbsp;Initial:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer3_init}</td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td colSpan="4">
                    <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                        <tbody>
                            <tr>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"25%", textAlign: "center"}}>Procedure</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"35%", textAlign: "center"}}>Reference</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Introduce</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainer Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainee Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Proficient</th>
                            </tr>
                            <ViewDetails records={props.record} ftype='content1' />
                            {(props.record && props.record.sub_heading) &&<tr>
                                <td colSpan="6" style={{backgroundColor: "silver", fontWeight: "bold", textAlign: "center"}}><Heading  data={props.record && props.record.sub_heading} /></td>
                            </tr>}
                            <ViewDetails records={props.record} ftype='content2' />
                        </tbody>
                    </table>
            
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Trainee Signature:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record.trainee_sign }</td>
                <td>&nbsp;Date:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record.trainee_sign_date && moment(props.record.trainee_sign_date).format('MM/DD/yyyy')}</td>
            </tr>
            <tr>
                <td>Center Manager Signature:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.mgr_sign}</td>
                <td>&nbsp;Date:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record.mgr_sign_date && moment(props.record.mgr_sign_date).format('MM/DD/yyyy')}</td>
            </tr>
            <tr>
                <td>Quality Assurance Signature:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.qa_sign}</td>
                <td>&nbsp;Date:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record.qa_sign_date && moment(props.record.qa_sign_date).format('MM/DD/yyyy')}</td>
            </tr>
            </tbody>
        </table>
        </SimpleShowLayout>
    </Show>
);


const GetKey=({ props }) => (
    uid = (props.location)?( (props.location.uid)?props.location.uid:uid):uid,
    (uid)? '': <Redirect to="/userslist" />
);

export const CheckListFull = props => (
    <List 
        {...props}
        filters={<NameFilter />}
        actions={<Actions/>} 
        perPage={20}
        sort={{ field: 'name', order: 'ASC' }}
        bulkActionButtons ={false}
        >
        <Datagrid  expand={<PostShow />} >
            <GetKey props ={props} />
            <TextField source="name" label="Name" />
            <DateField source="created_date" label="Date"  locales="en-us" />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);


export default CheckListFull